<!-- Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. -->

<button-footer
	automationId="reportButtonFooter"
	[attr.automationURL]="downloadUrl"
	[ngSwitch]="stateUI$ | async"
	(buttonSaveOrClose)="runCancelViewReportEvent()"
	[saveOrCloseButtonText]="runCancelViewReportText$ | async | uppercase"
	[disabled]="(stateUI$ | async) === reportUIState.EditingOptions && disableRunReportButton"
>
	<button
		*ngSwitchCase="reportUIState.EditingOptions"
		leftButton
		mat-button
		color="primary"
		(click)="clearSettingsEvent()"
		automationId="reportPanelClear"
	>
		{{ strings.UICONTROL_TEXT_CLEAR_SETTINGS | uppercase }}
	</button>
	<div leftButton class="left-section" *ngSwitchCase="reportUIState.RunningReport">
		<mat-status-indicator
			class="indicator"
			automationId="runningReportIndicator"
			[state]="stateLoadingIndicator$ | async"
			[spinnerMode]="'determinate'"
			[scalePercent]="50"
			[spinnerValue]="reportProgress$ | async"
		>
		</mat-status-indicator>
		<span automationId="runningReportLabel">{{ strings.REPORT_RUNNING_REPORT }}</span>
	</div>
	<div leftButton *ngSwitchCase="reportUIState.ReadyToViewReport">
		<button mat-button color="primary" (click)="editSettingsEvent()" automationId="reportEditSettings">
			{{ strings.REPORT_EDIT_SETTINGS | uppercase }}
		</button>
	</div>
	<div leftButton *ngSwitchCase="reportUIState.ReadyToDownload">
		<button
			mat-button
			color="primary"
			(click)="editSettingsEvent()"
			automationId="reportEditSettingsDownloadCSV"
		>
			{{ strings.REPORT_EDIT_SETTINGS | uppercase }}
		</button>
	</div>
</button-footer>
